var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userAllowedToSee)?_c('div',{class:_vm.$vnode.data.staticClass,style:(_vm.$vnode.data.staticStyle)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }